export default {
      id: "edin_vmes-usage",
      viewBox: "0 0 43 43",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#edin_vmes",
      toString: function () {
        return this.url;
      }
    }